import React from 'react'
import CosmeticProductFormPage from './Form'
import { useParams } from 'react-router-dom'

export default function CosmeticProductEditPage() {
  const { id } = useParams<{ id?: string }>()
  return <CosmeticProductFormPage productEan={id} />
}
